import React, { useState } from "react";
import { Mail } from "lucide-react";

const ForgotPassword = () => {

  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");

  const [error, setError] = useState("");

  // =========================
  // SEND RESET MAIL
  // =========================

  const handleSubmit = async (e) => {

    e.preventDefault();

    setError("");
    setMessage("");

    try {

      setLoading(true);

      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            email,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {

        setError(data.message || "Email not found");

        return;
      }

      setMessage(data.message);

    } catch (error) {

      console.error(error);

      setError("Server error");

    } finally {

      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#e5ecff] flex items-center justify-center p-4">

      <div className="bg-white rounded-xl shadow-md p-6 border border-gray-200 w-full max-w-md">

        <h1 className="text-2xl font-bold text-center mb-6">
          Forgot Password
        </h1>

        <p className="text-sm text-gray-500 text-center mb-6">
          Enter your registered email address
        </p>

        {message && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg text-green-600 text-sm">
            {message}
          </div>
        )}

        {error && (
          <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">

          <div className="relative">

            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />

            <input
              type="email"
              required
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full pl-10 pr-3 py-2.5 border border-slate-200 rounded-lg"
            />

          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-blue-600 text-white py-2.5 rounded-lg"
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </button>

        </form>

      </div>

    </div>
  );
};

export default ForgotPassword;